// @flow

import React, { type Node, useState } from 'react';
import { SodexoWebview } from './sodexo/sodexo-webview';
import { SodexoForm } from './sodexo/sodexo-form';

export function SodexoPage(): Node {
  const [pageState, setPageState] = useState<PageStatus>('form');

  if (pageState === 'iframe') {
    return <SodexoWebview />;
  } else {
    return <SodexoForm pageStateSetter={setPageState}/>;
  }
}

export type PageStatus =
  | 'form'
  | 'iframe'
  | 'finished'
  ;
